<template>
  <router-link to="/" :class="['fullname','nohalo', {'hidden': $route.name === 'home'}]">Thomas Haaf<slot/></router-link>
</template>

<script>
export default {
 
};
</script>

<style lang="scss">
 @import '@/assets/scss/app.scss';
  .fullname {
    transition: 0.5s;
    position:absolute;
    text-shadow: 1px 1px 1px $neutral;
    flex: 1 1 auto;
    font-family: 'SourceCodePro Bold';
    font-weight :700;
    font-size: 1.5rem;
    line-height:1.1rem;
    color: $logo;
    padding: 0;
    justify-content: center;
    align-self: center;
    margin:$outerspace 0 0 $outerspace;
    text-transform: uppercase;
    text-decoration: none;
    z-index:98;
    mix-blend-mode: darken;
    @include breakpoint('s'){
      mix-blend-mode: normal;
    }
  }

  .darkmode {
    .fullname {
      text-shadow: 1px 1px 1px $logo;
      color: $neutral;
       mix-blend-mode: lighten;
    }
  }
</style>
